'use client';
import React from 'react';
import { OrderTimeline as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

const fmt = (iso?: string | null): string => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    });
  } catch {
    return '';
  }
};

/**
 * Storefront OrderTimeline — derives the fulfillment lifecycle (placed →
 * processing → shipped → delivered) from the real order + its first fulfillment,
 * and injects the tracking number. Falls back to the shared MOCK when no order.
 */
function OrderTimelineImpl(props: any) {
  const { order } = useOrderData();
  if (!order) {
    return <SharedRender {...props} />;
  }

  const f = (order as any).fulfillments?.[0];
  const steps = [
    {
      id: 'placed', title: 'Order Placed', description: 'Your order has been confirmed',
      timestamp: fmt(order.created_at as any), completed: true, iconName: 'Check',
    },
    {
      id: 'processing', title: 'Processing', description: "We're preparing your order",
      timestamp: fmt(f?.packed_at), completed: !!f, iconName: 'Clock',
    },
    {
      id: 'shipped', title: 'Shipped', description: 'Your order is on its way',
      timestamp: fmt(f?.shipped_at), completed: !!f?.shipped_at, iconName: 'Truck',
    },
    {
      id: 'delivered', title: 'Delivered', description: 'Your order has been delivered',
      timestamp: f?.delivered_at ? fmt(f.delivered_at) : 'Pending', completed: !!f?.delivered_at, iconName: 'Package',
    },
  ];

  const trackingNumber = f?.labels?.[0]?.tracking_number;

  return <SharedRender {...props} steps={steps} trackingNumber={trackingNumber} />;
}

export const OrderTimeline: any = {
  ...Shared,
  render: (props: any) => <OrderTimelineImpl {...props} />,
};

export default OrderTimeline;
